export default __webpack_public_path__ + "static/slide-frame-paper1-81e12ad72a01ff6a0c2cd10f3155c011.png";